<template>
  <v-container>
    <template v-if="group">
      <h2 class="mb-2">Группа компетенций &laquo;{{ group.name }}&raquo;</h2>
      <div v-if="group.description" class="mt-1 mb-2">
        {{ group.description }}
      </div>
      <div>
        <div>
          <div>
            Дата начала мероприятий:
            {{ formatDate(group.event_start_limit) || "не указана" }}
          </div>
          <div>
            Дата создания достижений:
            {{ formatDate(group.achievement_created_limit) || "не указана" }}
          </div>
        </div>
        <div class="mt-2">
          <v-btn
            color="primary"
            :title="`Редактировать группу ${group.name}`"
            @click.stop="showModal = true"
          >
            Редактировать
          </v-btn>
        </div>
      </div>

      <div v-if="list.length" class="mt-4">
        <v-simple-table class="mb-3">
          <template #default>
            <thead>
              <tr>
                <th class="text-left" width="100">id</th>
                <th class="text-left">Название компетенции</th>
                <th class="text-left">Ограничивающий коэф.</th>
                <th class="text-left">Код</th>
                <th class="text-left">Мероприятие</th>
                <th class="text-left">Показывать в ЛК</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in list"
                :key="item.id"
                :class="{ 'is-disabled': !item.is_active && isTalentGroup }"
                @click="
                  $router.push({
                    name: 'competence_tracks',
                    params: { id: item.id },
                  })
                "
              >
                <td>{{ item.id }}</td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.limit_coefficient }}
                </td>
                <td>
                  {{ item.code }}
                </td>
                <td>{{ item.event_id }}</td>
                <td>{{ item.is_active ? "Да" : "Нет" }}</td>
                <td width="120px" class="text-right">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="hover ? 'primary' : 'grey lighten-1'"
                      title="Редактировать компетенцию"
                      icon
                      @click.stop="openCompetenceDialog(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </v-hover>

                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="hover ? 'error' : 'grey lighten-1'"
                      title="Удалить компетенцию"
                      icon
                      @click.stop="handleRemove(item.id)"
                    >
                      <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                  </v-hover>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </template>
    <group-dialog v-model="showModal" :group="group" />

    <competence-create-dialog
      v-model="createDialog"
      :competence="selectedCompetence"
      :lock-group="true"
      :selected-group-id="group && group.id"
    />

    <v-btn
      color="primary"
      class="mt-4"
      :disabled="!group"
      @click.stop="createCompetence"
      >Добавить компетенцию</v-btn
    >
  </v-container>
</template>

<script>
import { GroupDialog } from "@/components/groups";
import CompetenceCreateDialog from "@/components/dialogs/CompetenceCreateDialog";
import { TALENT_GROUP_CODE } from "@/constants";

import dayjs from "@/plugins/dayjs";
import { apiClient } from "@/api";

export default {
  name: "ViewGroup",
  components: {
    GroupDialog,
    CompetenceCreateDialog,
  },
  data() {
    return {
      showModal: false,
      createDialog: false,
      selectedCompetence: null,
    };
  },
  computed: {
    group() {
      return this.$store.state.groups[this.$route.params.id];
    },
    isTalentGroup() {
      return this.group?.code === TALENT_GROUP_CODE;
    },
    list() {
      return this.$store.state.competences.filter(
        (n) => n.group_id === +this.$route.params.id
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("getAllGroups");
      await this.$store.dispatch("getAllCompetence");
    },
    formatDate(date) {
      if (!date) return;
      return dayjs(date).format("LLLL");
    },
    async handleRemove(id) {
      if (!id) return;
      const confirm = await this.$root.$confirm(
        "Удалить компетенцию",
        "Это действие необратимо. Вы уверены что хотите удалить компетенцию?",
        {
          confirmText: "Да, удалить",
          rejectText: "Нет, отмена",
        }
      );
      if (!confirm) return;
      try {
        await apiClient({
          method: "DELETE",
          url: `/competences/${id}`,
        });
        this.$store.commit("DELETE_COMPETENCE", id);
      } catch (error) {
        this.$toast(`Не удалось удалить компетенцию. ${error.message}`, {
          type: "error",
        });
      }
    },
    openCompetenceDialog(item) {
      this.selectedCompetence = item;
      this.createDialog = true;
    },
    createCompetence() {
      this.selectedCompetence = null;
      this.createDialog = true;
    },
  },
};
</script>

<style></style>
